/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ coupons: NonNullable<unknown> }} Neat_Petty_Mongoose_TreatInputs */

const fr_neat_petty_mongoose_treat = /** @type {(inputs: Neat_Petty_Mongoose_TreatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il te reste actuellement ${i?.coupons} séances.`)
};

/**

* @param {Neat_Petty_Mongoose_TreatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const neat_petty_mongoose_treat = /** @type {((inputs: Neat_Petty_Mongoose_TreatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Petty_Mongoose_TreatInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_neat_petty_mongoose_treat(inputs)
});